<template>
  <div class="kiuCustom-Select" :class="{ '--opened': opened }">
    <button
      class="select-button"
      ref="customSelect"
      role="combobox"
      aria-labelledby="select button"
      aria-haspopup="listbox"
      aria-expanded="false"
      aria-controls="select-dropdown"
      @click="opened = !opened"
    >
      <span class="selected-value">
        {{ $t(selectedOption?.label) }}
      </span>
      <span class="arrow"></span>
      <!-- <i class="fa-solid fa-list"></i> -->
    </button>
    <div
      class="select-dropdown"
      ref="selectDropdown"
      role="listbox"
      id="select-dropdown"
    >
      <!-- TODO: AGREGAR LABELS -->
      <header class="dropdown-title">
        {{ $t(headerLabel) }}
        <button class="dropdown-close" @click="onClose">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>
      <li role="option" v-for="(option, key) in options" :key="key">
        <label @click="onSelectOption(option)" ref="optionLabels">
          {{ $t(option.label) }}
        </label>
      </li>
    </div>
  </div>
</template>
<script>
import { closableDirective } from '../../helpers/directives.js'
import { useResize } from '../../helpers/useResize.js'
export default {
  name: 'KiuSelect',
  directives: {
    closable: closableDirective,
  },
  props: {
    options: {
      type: Array,
      default: function () {
        return []
      },
    },
    defaultValue: {
      type: Object,
      required: false,
    },
    headerLabel: {
      type: String,
      default: 'sort_by',
    },
  },
  data: function () {
    return {
      opened: false,
      selectedOption: null,
      breakpoints: null,
    }
  },
  mounted: function () {
    this.breakpoints = useResize()
    if (this.defaultValue) {
      this.selectedOption = this.defaultValue
    } else {
      this.selectedOption = this.options[0]
    }
    this.$nextTick(() => this.setDrowpdownWidth())
  },
  watch: {
    selectedOption: function (newOption) {
      this.$emit('input', newOption)
    },
  },
  methods: {
    onSelectOption: function (option) {
      this.selectedOption = option
      this.opened = false
    },
    setDrowpdownWidth() {
      const labelElements = this.$refs.optionLabels
      if (!this.breakpoints.isDesktop) {
        this.$refs.customSelect.style.width = '100%'
        this.$refs.selectDropdown.style.width = 'fit-content'
        return
      }

      let maxWidth = 0
      labelElements.forEach((label) => {
        const labelWidth = label.offsetWidth
        maxWidth = Math.max(maxWidth, labelWidth)
      })
      const width = maxWidth + 15 + 'px'
      this.$refs.customSelect.style.width = width
      this.$refs.selectDropdown.style.width = width
    },
    onClose: function () {
      this.opened = false
    },
  },
}
</script>
<style scoped lang="sass">
.kiuCustom-Select
  position: relative
  min-width: 100%
  font-size: var(--font-size-base)
  font-weight: 400
  color: var(--color-primary)
  line-height: 1.2rem
  &.--opened
    .select-button
      border-radius: 0.1875rem 0.1875rem 0 0
      border-bottom: none
  &:after
    content: ''
    position: fixed
    top: 0
    left: 0
    width: 100dvw
    height: 100dvh
    background: var(--color-onSurface)
    opacity: 0.5
    z-index: 200
    display: none
.select-button
  gap: .5rem
  font-size: var(--font-size-base)
  background-color: var(--color-surface)
  padding: 0.675em 0 0.675em 1em
  border: 1px solid var(--color-overlay-20)
  border-radius: 0.1875rem
  cursor: pointer
  max-height: 2.5rem
  display: flex
  align-items: center
  white-space: nowrap
.selected-value
  text-align: left
  color: var(--color-primary)
.arrow
  position: absolute
  right: 0
  border-left: 5px solid transparent
  border-right: 5px solid transparent
  margin-right: 0.675em
  transition: transform ease-in-out 0.3s
  border-top: 6px solid var(--color-primary)
.select-dropdown
  position: fixed
  list-style: none
  white-space: nowrap
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2)
  background-color: var(--color-surface)
  border: 1px solid var(--color-overlay-20)
  border-radius: 0 0 0.1875rem 0.1875rem
  padding: 0
  overflow-y: auto
  transition: 0.3s ease-out
  opacity: 0
  visibility: hidden
  z-index: 999
  // responsive
  top: 50%
  left: 50%
.select-dropdown li
  position: relative
  cursor: pointer
  display: flex
  gap: 1rem
  align-items: center
  max-height: 2.5rem
.select-dropdown li label
  width: 100%
  padding: 0.675em 1em
  cursor: pointer
  display: flex
  gap: 1rem
  align-items: center
  justify-content: flex-start

.select-dropdown::-webkit-scrollbar
  width: 7px
.select-dropdown::-webkit-scrollbar-track
  background: var(--color-surface)
  border-radius: 25px

.select-dropdown::-webkit-scrollbar-thumb
  background: #ccc
  border-radius: 25px

.select-dropdown li:hover
  background-color: #f2f2f2
  transform: scale(1.05)
  // font-weight: 500
.kiuCustom-Select.--opened
  &:after
    display: block
.kiuCustom-Select.--opened .arrow
  transform: rotate(180deg)

.dropdown-title
  display: flex
  justify-content: space-between
  align-items: center
  padding: 0.5rem
  font-weight: 300
  font-size: 0.875rem
  line-height: 1.375rem
  padding: .5rem 0 .5rem .5rem
  i
    font-weight: 900
    font-size: 0.875rem
.dropdown-close
  all: unset
  cursor: pointer

.kiuCustom-Select.--opened .select-dropdown
  opacity: 1
  visibility: visible
  transform: translate(-50%, -50%)
  padding: 0 1rem
  z-index: 999
  border-radius: 0.25rem
  border: 1px solid var(--color-overlay-20)

@media (min-width: 1024px)
  .kiuCustom-Select
    max-width: 100%
    min-width: 0
  .select-dropdown
    position: absolute
    top: 100%
    left: 0
  .select-button, .select-dropdown li label
    justify-content: flex-start
  .kiuCustom-Select.--opened .select-dropdown
    transform: scaleY(1)
    padding: 0
    border-radius: 0
    border-top: none
  .dropdown-title
    display: none
  .kiuCustom-Select.--opened
    &:after
      display: none
</style>
